<div class="app-body body-background">
  <main class="main d-flex align-items-center">
    <div class="container-login100">
      <div class="wrap-login100">
        <div class="mid-tit-le">
          <img class="img-center" src="assets/img/brand/logo_jayaraya.svg">
          <span class="tit-le">eRBA DKI Jakarta</span>
          <span class="sub-tit-le">SELAMAT DATANG, SILKAN LOGIN</span>
        </div>
        <form [formGroup]="formGroup" (submit)="login()">
          <div class="input-group mb-form">
            <input type="text" class="form-control" placeholder="NRK" autocomplete="username" formControlName="username"
              (input)="onInput($event)" />
          </div>
          <div class="input-group mb-form">
            <div class="input-group" style="flex-wrap: nowrap; max-width:98%">
              <input type="password" class="form-control" placeholder="Kata Kunci" autocomplete="current-password"
                formControlName="password" [type]="passwordFieldType" />
              <button type="button" class="btn password-toggle-btn" (click)="togglePasswordVisibility()">
                <i class="fa" [ngClass]="passwordFieldType === 'password' ? 'fa-eye' : 'fa-eye-slash'"></i>
              </button>
            </div>
          </div>
          <div class="row mb-form">
            <div class="col-6">
              <input type="text" class="form-control" placeholder="Ketik Captcha" formControlName="captcha" [ngClass]="{
                'is-invalid': formGroup.controls.captcha.errors || checkCaptcha(),
                'is-valid': !formGroup.controls.captcha.valid || !checkCaptcha()}">
            </div>
            <div class="col-6 text-center">
              <span class="form-control captcha" (click)="randomCaptcha(5)">{{captchaValue}}</span>
            </div>
          </div>
          <div class="input-group mb-form">
            <button [disabled]="formGroup.invalid" type="submit" class="btn-lojin">
              Login
            </button>
          </div>
        </form>
      </div>
    </div>
  </main>
</div>